import { render, staticRenderFns } from "./UnauthorisedParkingApprove.vue?vue&type=template&id=0f6f2eba"
import script from "./UnauthorisedParkingApprove.vue?vue&type=script&lang=js"
export * from "./UnauthorisedParkingApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports